module.exports = __webpack_public_path__ + "media/images/version_merge/photostep_trash/like_this_cmnd_selfie_actual-deb21c81a92f47b5614237b3f17b0c6c.jpg";